import React from 'react';
import './css/epk.css';
import PhotoGalleryEPK from './sub-components/PhotoGalleryEPK';
import Review from './sub-components/review';
import Songlist from "./sub-components/Songlist";
import EPKCalendar from "./sub-components/EPKCalendar";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

const EPK = () => { // (Arrow Function Declaration)
    return (
        <div className="epk backer">

            <div className="col-12 bio">
                {/*<div className="top-social">*/}
                {/*    <div className="facebook">*/}
                {/*        <a href="https://www.facebook.com/DYSYachtRock" target="_blank" className="fb-like " data-width="270" data-layout="button" data-action="like" data-size="large" data-share="true"><FontAwesomeIcon icon={faFacebook} /></a>*/}
                {/*    </div>*/}
                {/*    <div className="instagram">*/}
                {/*        <a href="https://instagram.com/dirtyyachtin" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <h1 className="bio_title">Yacht Rock Band</h1>

                <PhotoGalleryEPK />
                <div className="hl"></div>

               {/* <Review />*/}

                <div className="hl"></div>
                <h3>Video</h3>
                <div className="video-container">
                   
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/0Y4qfkB70kQ?si=8Xhn3z7npubhYq3U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

                <div className="hl"></div>

                <div>
                    <h3>Bio</h3>
                    <p className="bio_text">
                        Smooth grooves, tight harmonies, and a knack for transporting audiences straight back to the golden era of soft rock—this six-piece ensemble delivers an unforgettable musical journey. With decades of combined experience, each member brings a wealth of talent on vocals, guitars, keys, bass, and drums, perfectly blending musicianship with charisma.
                    </p>

                    <p className="bio_text">
                        Their setlists are a carefully curated collection of the 70s and 80s yacht rock classics, ensuring every performance is both nostalgic and electrifying. Known for engaging live shows, they captivate audiences with seamless transitions, lush harmonies, and irresistible grooves that invite dancing, singing along, and pure enjoyment.
                    </p>

                    <p className="bio_text">
                        From intimate venues to large festivals, this group has honed the art of creating an immersive musical experience, balancing precision with spontaneous energy. Each performance is more than a show—it’s a celebration of smooth rock’s timeless appeal, executed with professionalism, passion, and a hint of playful charm.
                    </p>

                    <p className="bio_text">
                        Whether playing a private event, corporate function, or public concert, audiences can expect a set full of unforgettable hits, impeccable sound, and a vibe that leaves everyone smiling long after the final note fades.
                    </p>
                </div>

                <div className="hl"></div>

                <div className="epk-container">
                    <div className="epk-left">
                        <Songlist />
                    </div>
                    <div className="epk-right">
                        <EPKCalendar />
                    </div>
                </div>

            </div>

        </div>

    );
}
export default EPK
